import { api } from './client';
export const getMeta=()=>api.get('/meta/latest').then(r=>r.data);
export const getCoverage=params=>api.get('/meta/coverage',{params}).then(r=>r.data);
export const getOverview=params=>api.get('/dashboard/overview',{params}).then(r=>r.data);
export const getRankings=params=>api.get('/dashboard/rankings',{params}).then(r=>r.data);
export const getSeries=params=>api.get('/prices/series',{params}).then(r=>r.data);
export const getMultiSeries=params=>api.get('/prices/multi-series',{params}).then(r=>r.data);
export const getMonthlyComponents=params=>api.get('/prices/monthly-components',{params}).then(r=>r.data);
export const getEuLatest=params=>api.get('/eu/prices/latest',{params}).then(r=>r.data);
export const getEuRanking=params=>api.get('/eu/prices/ranking',{params}).then(r=>r.data);
export const getEuSeries=params=>api.get('/eu/prices/series',{params}).then(r=>r.data);
export const getEuGap=params=>api.get('/eu/prices/gap',{params}).then(r=>r.data);
export const getEuTaxes=params=>api.get('/eu/taxes/latest',{params}).then(r=>r.data);
export const getMapStations=params=>api.get('/map/stations',{params}).then(r=>r.data);
export const searchTerritories=q=>api.get('/territories/search',{params:{q}}).then(r=>r.data.items);
export const getStation=id=>api.get(`/stations/${id}`).then(r=>r.data);
export const getStationOptions=(id,params)=>api.get(`/stations/${id}/options`,{params}).then(r=>r.data);
export const getStationHistory=(id,params)=>api.get(`/stations/${id}/history`,{params}).then(r=>r.data);
export const getStationBenchmarks=(id,params)=>api.get(`/stations/${id}/benchmarks`,{params}).then(r=>r.data);
export const getMethodology=()=>api.get('/methodology').then(r=>r.data);
export const login=credentials=>api.post('/admin/login',credentials).then(r=>r.data);
export const getAdminImports=()=>api.get('/admin/imports').then(r=>r.data);
export const runCurrentSync=()=>api.post('/admin/imports/sync').then(r=>r.data);
